import React, { useContext, useEffect, useState } from "react";
import { AppContext } from "../../AppContext";
import "./Pipeline.css";
import Clients from "../Application/Clients/Clients";
import UnderContract from "../Application/Under Contract/UnderContract";
import PipelineButtons from "./PipelineButtons";
import { PipelineButtonContext } from "./PipelineButtonContext";

const Pipeline = () => {
  const {
    navigate,
    path,
    windowWidth,

  } = useContext(AppContext);

  const { displayComponent, setDisplayComponent } = useContext(
    PipelineButtonContext
  );


  useEffect(() => {
    setTimeout(() => {
      navigate(path);
    }, 0);
    path == "/pending" || path == "/preapproved"
      ? setDisplayComponent(<Clients />)
      : setDisplayComponent(<UnderContract />);
  }, [path]);

  return (
    <>
      {windowWidth < 750 ? null : <PipelineButtons />}
      {displayComponent}
    </>
  );
};

export default Pipeline;
